class DrawerMenu extends HTMLElement {
  constructor() {
    'use strict';
    super();

    this.el = this;
    this.mainLevel = this.el.querySelector('.drawer-menu__contents');

    // Bind methods once to reuse the same function reference
    this.boundToggleSubSubMenuItem = this.toggleSubSubMenuItem.bind(this);

    this.init();
  }

  init() {
    // These toggle submenu panel
    this.firstLevelItemsWithChildren = this.el.querySelectorAll('.drawer-menu__item__input');
    this.firstLevelItemsWithChildren.forEach((input) => {
      input.addEventListener('change', this.toggleMenuItem.bind(this));
    });

    this.secondLevelItemsWithChildren = this.el.querySelectorAll('.drawer-submenu__item__input');
    this.secondLevelItemsWithChildren.forEach((input) => {
      input.addEventListener('change', this.toggleSubMenuItem.bind(this));
    });

    this.thirdLevelItemsWithChildren = this.el.querySelectorAll('.drawer-subsubmenu__item__input');
    this.thirdLevelItemsWithChildren.forEach((input) => {
      input.addEventListener('change', this.boundToggleSubSubMenuItem);
    });

    // These handle closing of navigation
    this.closeButtons = this.el.querySelectorAll('[data-close]');
    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', this.closeAllItems.bind(this));
    });

    this.overlay = this.el.querySelector('[data-overlay]');
    this.overlay.addEventListener('click', this.closeAllItems.bind(this));

    // These handle going back to previous panel
    this.secondLevelBackButtons = this.el.querySelectorAll('[data-drawer-submenu-close]');
    this.secondLevelBackButtons.forEach((button) => {
      button.addEventListener('click', this.toggleSubPanel.bind(this));
    });

    // Handle opening of specific subitem from anywhere in the theme
    this.subitemOpeners = document.querySelectorAll('[data-drawer-submenu-open]');
    this.subitemOpeners.forEach((button) => {
      button.addEventListener('click', this.toggleMenuItemFromTheme.bind(this));
    });
  }

  closeAllItems(event, skipEl) {
    const checkboxes = this.mainLevel.querySelectorAll('input:checked');
    checkboxes.forEach((checkbox) => {
      if (skipEl && checkbox === skipEl) {
        return;
      }
      checkbox.checked = false;
      const accordion = checkbox.closest('[data-accordion-item]');
      if (accordion) {
        accordion.classList.remove('is-open');
        if (screen.width <= 820) {
          const parent = accordion.closest('.drawer-menu__contents');
          parent.classList.remove('pull-left');
        }
      }
    });

    if (!skipEl) {
      this.mainLevel.classList.remove('has-open-submenu');
    }
  }

  toggleMenuItem(scope) {
    const input = scope.currentTarget || scope;
    if (!input) return;

    this.closeAllItems(scope, input);

    const accordion = input.closest('[data-accordion-item]');
    if (!accordion) {
      return;
    }
    if (screen.width <= 820) {
      const parent = accordion.closest('.drawer-menu__contents');
      parent.classList.toggle('pull-left');
    }

    accordion.classList.toggle('is-open');
    if (accordion.classList.contains('is-open')) {
      this.mainLevel.classList.add('has-open-submenu');
    } else {
      this.mainLevel.classList.remove('has-open-submenu');
    }
  }

  toggleSubMenuItem(scope) {
    const input = scope.currentTarget || scope;
    if (!input) return;

    const accordion = input.closest('[data-accordion-item]');
    if (!accordion) {
      return;
    }

    // Close other level 2 accordions in the same submenu panel
    const parentPanel = accordion.closest('.drawer-submenu__panel');
    if (parentPanel) {
      const otherAccordions = parentPanel.querySelectorAll('[data-accordion-item].--collapsible.is-open');
      otherAccordions.forEach((otherAccordion) => {
        if (otherAccordion !== accordion) {
          otherAccordion.classList.remove('is-open');
          const otherInput = otherAccordion.querySelector('.drawer-submenu__item__input');
          if (otherInput) {
            otherInput.checked = false;
          }
        }
      });
    }

    // Toggle the clicked accordion open/closed without the pull-left animation
    accordion.classList.toggle('is-open');

    // Re-attach listeners for level 3 items after opening (they're loaded dynamically)
    if (accordion.classList.contains('is-open')) {
      setTimeout(() => {
        this.attachLevel3Listeners();
      }, 50);
    }
  }

  attachLevel3Listeners() {
    const thirdLevelItems = this.el.querySelectorAll('.drawer-subsubmenu__item__input');
    console.log('attachLevel3Listeners: Found', thirdLevelItems.length, 'level 3 items');

    thirdLevelItems.forEach((input) => {
      // Check if listener already attached
      if (!input.hasAttribute('data-listener-attached')) {
        input.addEventListener('change', this.boundToggleSubSubMenuItem);
        input.setAttribute('data-listener-attached', 'true');
        console.log('attachLevel3Listeners: Added listener to', input.id);
      }
    });
  }

  toggleSubSubMenuItem(scope) {
    console.log('toggleSubSubMenuItem: Called');
    const input = scope.currentTarget || scope;
    if (!input) {
      console.log('toggleSubSubMenuItem: No input found');
      return;
    }
    console.log('toggleSubSubMenuItem: Input', input.id, 'checked:', input.checked);

    const accordion = input.closest('[data-accordion-item]');
    if (!accordion) {
      console.log('toggleSubSubMenuItem: No accordion found');
      return;
    }
    console.log('toggleSubSubMenuItem: Accordion found, current classes:', accordion.className);

    // Close other level 3 accordions in the same subsubmenu panel
    const parentPanel = accordion.closest('.drawer-subsubmenu__panel');
    if (parentPanel) {
      const otherAccordions = parentPanel.querySelectorAll('[data-accordion-item].--collapsible.is-open');
      otherAccordions.forEach((otherAccordion) => {
        if (otherAccordion !== accordion) {
          otherAccordion.classList.remove('is-open');
          const otherInput = otherAccordion.querySelector('.drawer-subsubmenu__item__input');
          if (otherInput) {
            otherInput.checked = false;
          }
        }
      });
    }

    // Toggle the clicked accordion open/closed without the pull-left animation
    accordion.classList.toggle('is-open');
    console.log('toggleSubSubMenuItem: Toggled, new classes:', accordion.className);
  }

  toggleMenuItemFromTheme(scope) {
    let target = false;
    const button = scope.currentTarget || scope;
    const url = button.getAttribute('data-drawer-submenu-open');

    for (const input of this.firstLevelItemsWithChildren) {
      if (input.getAttribute('data-href') === url) {
        target = input;
        break;
      }
    }

    if (!target) return;

    Woolman.ModalsAndDrawers.showModalOrDrawer(this.el.getAttribute('id'));

    const animationFinished = () => {
      this.el.removeEventListener('transitionend', animationFinished);

      const evt = new Event('change');
      target.checked = true;
      target.dispatchEvent(evt);
    };
    this.el.addEventListener('transitionend', animationFinished);
  }

  toggleSubPanel(event) {
    this.closeAllItems();

    const button = event.currentTarget;
    const targetSelector = button.getAttribute('data-drawer-submenu-close');
    if (!targetSelector) {
      return;
    }

    const input = document.getElementById(targetSelector);
    if (!input) {
      return;
    }

    input.focus();
  }
}

if (customElements.get('drawer-menu') === undefined) {
  customElements.define('drawer-menu', DrawerMenu);
}
